import { useState, useEffect } from 'react'
import { listSurveys } from '../services/survey-config-api'
import type { SurveyConfig } from '../types/survey.types'

interface UseSurveysState {
  surveys: SurveyConfig[]
  loading: boolean
  error: Error | null
  refresh: () => void
}

export function useSurveys(): UseSurveysState {
  const [surveys, setSurveys] = useState<SurveyConfig[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    let cancelled = false

    const fetchSurveys = async () => {
      try {
        setLoading(true)
        setError(null)
        const data = await listSurveys()
        if (!cancelled) {
          setSurveys(data)
          setLoading(false)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error('Failed to fetch surveys'))
          setLoading(false)
        }
      }
    }

    fetchSurveys()

    return () => {
      cancelled = true
    }
  }, [refreshKey])

  const refresh = () => {
    setRefreshKey(prev => prev + 1)
  }

  return { surveys, loading, error, refresh }
}
